import { Injectable } from '@angular/core';
import { RequestsProvider } from '../requests/requests';
import { LoggerFactory } from '../logger/logger-factory.service';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { environment } from '../../../../environments/environment';

/**
 * Equipes Provider
 *
 * Ce service permet d'accéder aux service de l'API UOs (équipes)
 */
@Injectable({ providedIn: 'root' })
export class EquipesProvider {
  /**
   * Utilisé pour l'url de config de l'API
   *
   * @type {string}
   */
  apiUrl = '';

  /**
   * Logger
   */
  private logger: LoggerWrapper;

  equipes: any = [];

  /**
   * Constructeur
   *
   * Crée une instance de EquipementsProvider.
   *
   * @param {RequestsProvider} requestsProvider
   */
  constructor(
    private requestsProvider: RequestsProvider,
    private loggerFactory: LoggerFactory
  ) {
    this.logger = this.loggerFactory.getInstance(this);
    this.apiUrl = environment.apis.API_EQUIPES;
  }

  /**
   * Récupération de l'équipe a partir de l'id de l'utilisateur
   */
  async refreshEquipes(idUser: string) {
    return this.requestsProvider
      .get(this.apiUrl + '?idIntervenant=' + idUser)
      .then((data) => {
        this.equipes = data;
        return data;
      })
      .catch((err) => {
        this.logger.warn('error getCatalogue', err);
      });
  }

  /**
   * Récupération de l'équipe de l'utilisateur
   */
  getEquipes() {
    return this.equipes;
  }
}
